import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import i18n from "../../../../../../lib/i18n/i18n";
import { useTranslation } from "react-i18next";
import {
  Body,
  AdditionalDetailsContainer,
  Button,
  Fields,
  ButtonContainer,
} from "./dates.styles";
import { updateTextBookDates } from "../../../../../../actions/textBooksActions";
import { updateStudent } from "../../../../../../actions/studentesActions";
import moment from "moment";

const currLanguage = i18n.language;
const dictionary = i18n.getDataByLanguage(currLanguage).common;

const TextBookGeneral = ({
  handleSubmit,
  renderDatePickerField,
  updateTextBookDates,
  setIsLoading,
  closeModal,
  updateStudent,
  studentData
}) => {
  const { t, i18n } = useTranslation("common");
  const userCreateAction = async (formValues) => {
    setIsLoading(true);
    await updateStudent({
      id: studentData.id,
      medicalInstitute: moment(formValues.medicalInstitute).format(),
      certificateOfGoodConduct: moment(formValues.certificateOfGoodConduct).format()
    });
    studentData.medicalInstitute = formValues.medicalInstitute
    studentData.certificateOfGoodConduct = formValues.certificateOfGoodConduct
    delete formValues.medicalInstitute
    delete formValues.certificateOfGoodConduct
    await updateTextBookDates(formValues);
    setIsLoading(false);
    closeModal();
  };
  return (
    <Body onSubmit={handleSubmit(userCreateAction)}>
      <Fields>
        <AdditionalDetailsContainer>
          <Field
            name="documentCheck"
            component={renderDatePickerField}
            placeholder="הזנה בברוש"
          />
          <Field
            name="formEntry"
            component={renderDatePickerField}
            placeholder="הזנת מסמכים"
          />
          <Field
            name="certificateOfGoodConduct"
            component={renderDatePickerField}
            placeholder={t("newStudent.certificateOfGoodConduct")}
          />
          <Field
            name="medicalInstitute"
            component={renderDatePickerField}
            placeholder={t("newStudent.medicalInstitute")}
          />
        </AdditionalDetailsContainer>
        <AdditionalDetailsContainer>
          <Field
            name="eyeExamination"
            component={renderDatePickerField}
            placeholder="בדיקת עיניים"
          />
          <Field
            name="theory"
            component={renderDatePickerField}
            placeholder="תאוריה"
          />
          <Field
            name="medicalExamination"
            component={renderDatePickerField}
            placeholder="בדיקה רפואית"
          />
        </AdditionalDetailsContainer>
      </Fields>
      <ButtonContainer>
        <Button type="submit">{t("buttons.save")}</Button>
      </ButtonContainer>
    </Body>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    initialValues: {
      ...ownProps.textBookData,
      medicalInstitute: ownProps.studentData.medicalInstitute,
      certificateOfGoodConduct: ownProps.studentData.certificateOfGoodConduct,
      eyeExamination: ownProps.textBookData.eyeExamination
        ? ownProps.textBookData.eyeExamination
        : null,
      documentCheck: ownProps.textBookData.documentCheck
        ? ownProps.textBookData.documentCheck
        : null,
      formEntry: ownProps.textBookData.formEntry
        ? ownProps.textBookData.formEntry
        : null,
      theory: ownProps.textBookData.theory
        ? ownProps.textBookData.theory
        : null,
      medicalExamination: ownProps.textBookData.medicalExamination
        ? ownProps.textBookData.medicalExamination
        : null,
    },
  };
}

export default connect(mapStateToProps, { updateTextBookDates, updateStudent })(
  reduxForm({
    form: "textBookDates", // a unique identifier for this form
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    enableReinitialize: true,
  })(TextBookGeneral)
);
